// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"1e73051d","213":"8a53b317"}[chunkId] + ".chunk.js";
};